import BlankEtc from '@components/blank/BlankEtc';
import Header from '@components/Header';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import CloseLineIcon from '@icons/CloseLineIcon';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';

import NotificationItem from './components/NotificationItem';
import NotificationTitle from './components/NotificationTitle';
import useNotifications from './hooks/useNotifications';

const NotificationActivity: ActivityComponentType = () => {
  const {
    notifications, fetchNext, isLoading, isBlank,
  } = useNotifications();
  return (
      <AppScreen>
          <Header title=''
                  backIcon={CloseLineIcon}
                  noShadow />
          <NotificationTitle isBlank={isBlank}/>
          {notifications.map((notification, index) => (
              <NotificationItem notification={notification}
                                key={notification.notificationId} />
          ))}
          <InfinityScrollTrigger trigger={fetchNext} />
          {isLoading && (
              <Loading size='small'/>
          )}
          {isBlank && (
              <BlankEtc>
                  알림 내역이 없습니다.
              </BlankEtc>
          )}

      </AppScreen>
  );
};

export default NotificationActivity;
